module.exports = __webpack_public_path__ + "img/2.f94038b5.png";